import { PlanType } from "@zapier/canvas-state";

type GetNewProductUpgradeHrefParams = {
  tablesPlanType?: PlanType;
  interfacesPlanType?: PlanType;
  chatbotsPlanType?: PlanType;
};

/* Even if user is already on advanced, we will still link them to the advanced add-on
 * since we only have 1 upgrade button. They can find the custom plan info or chat with sales still
 * from that page.
 * */
export function getNewProductUpgradeHref({
  tablesPlanType,
  interfacesPlanType,
  chatbotsPlanType,
}: GetNewProductUpgradeHrefParams): string | undefined {
  const products = [];

  if (tablesPlanType) {
    products.push(`tables-${tablesPlanType}`);
  }

  if (interfacesPlanType) {
    products.push(`interfaces-${interfacesPlanType}`);
  }

  if (chatbotsPlanType) {
    products.push(`chatbots-${chatbotsPlanType}`);
  }

  if (products.length === 0) {
    return undefined;
  }

  return `/app/planbuilder/add-ons?${products.map((p) => `product=${p}`).join("&")}`;
}
